// src/App.js
import { AnimatePresence } from "framer-motion";

import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import BottomTabNav from "./components/BottomTabNav";
import { GlitchProvider, useGlitch } from "./context/GlitchContext"; // Import Glitch Context

import iPhoneStatusBar from "./assets/status-bar-withCamera.png"; // ✅ Import the status bar PNG
import iPhoneHomeIndicator from "./assets/HomeIndicator.png"; // ✅ Import the status bar PNG
import useIsMobile from "./components/useIsMobile"; // ✅ Import our mobile detection hook


import Typography from "./components/Typography";
import { spacing, borderRadius } from "./utils/tokens";
import { useTheme } from "./context/ThemeContext";


// Pages
import Today from "./pages/Today";
import Markets from "./pages/Markets";
import MyWSJ from "./pages/MyWSJ";
import Media from "./pages/Media";
import More from "./pages/More";
import MyQueue from "./pages/MyQueue";
import Assistant from "./pages/Assistant";
import Tiange from "./pages/Tiange";
import TakashiPlayground from "./pages/TakashiPlayground";
import LiveMarkets from "./pages/LiveMarkets";
import Company from "./pages/Company";
import QROverlay from "./components/QROverlay";
import Hotspots from "./components/Hotspots";
import DynamicHotspot from "./components/DynamicHotspot";

import "./pages/TakashiPlayground.css";
// Auth
import SignIn from "./pages/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import CustomCursor from "./components/CustomCursor";
import BackgroundController from "./components/BackgroundController";
import CreateWatchlist from "./pages/CreateWatchlist";
import PreviewWatchlist from "./components/PreviewWatchlist";


// Components
import LetterGlitch from "./components/LetterGlitch";
import Modal from "./components/Modal";

function GlitchOverlay() {
    const { showGlitch, glitchOpacity } = useGlitch();

    return showGlitch ? (
        <div style={{
            position: "fixed",
            top: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "black",
            zIndex: 3000,
            opacity: glitchOpacity,
            transition: "opacity 1s ease-in-out",
            pointerEvents: "none",
        }}>
            <LetterGlitch
                glitchSpeed={50}
                centerVignette={true}
                outerVignette={false}
                smooth={true}
                glitchHeight={window.innerHeight - 153}
            />
        </div>
    ) : null;
}

function AppContent() {
    
    const isMobile = useIsMobile(); // ✅ Detect mobile device
    
    const location = useLocation();    
    const [isHoveringPhone, setIsHoveringPhone] = useState(false);
    const [showHotspots, setShowHotspots] = useState(false); // ✅ Toggle State
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (location.pathname === "/signin") {
          document.body.classList.add("signin-page");
        } else {
          document.body.classList.remove("signin-page");
        }
      }, [location.pathname]);
      
    return (
            <>

            {!isMobile &&
                <>
                <GlitchOverlay /> {/* Persistent Glitch Effect */}
            <CustomCursor isHoveringPhone={isHoveringPhone}/>
            <QROverlay setShowHotspots={setShowHotspots} showHotspots={showHotspots} />
            {/* <Hotspots /> QR Code Section in the Top Left */}
            <BackgroundController /> {/* Background and Sound Logic Here */}

            <div className="background-ui"></div>
                </>
            }
                
            <div className="iphone-mockup"
            >
                {!isMobile &&
                    <>
                    <img src={iPhoneStatusBar} alt="iPhone Status Bar" className="iphone-status-bar" />
                    <img src={iPhoneHomeIndicator} alt="iPhone Home Indiciator" className="iphone-home-indicator" />
                    {showHotspots && (
                        <>
                    <DynamicHotspot
                        targetId="watchlist-summary"
                        title="Watchlist Summary"
                        description="This section provides an overview of your selected watchlist, showing key stock performance trends."
                        scrollContainerId="scroll-container-watchlist"
                        offsetX={70}
                        offsetY={-70}
                        tooltipPosition="left"
                    />
                    <DynamicHotspot
                        targetId="stock-list"
                        title="Stock List"
                        description="This section provides an overview of your selected watchlist, showing key stock performance trends."
                        scrollContainerId="scroll-container-watchlist"
                        offsetX={530}
                        offsetY={-410}
                        tooltipPosition="right"
                    />
                    <DynamicHotspot
                        targetId="overview-graph"
                        title="The Market and Updates at a Glance"
                        description="This section provides an overview of your selected watchlist, showing key stock performance trends."
                        scrollContainerId="scroll-container-watchlist"
                        offsetX={70}
                        offsetY={-180}
                        tooltipPosition="left"
                    />
                    </>
                    )}
                    <img src={require('./assets/iPhone 14 Pro.png')} alt="iPhone Frame" className="iphone-frame" />
                    </>
            }
                    <div className="iphone-screen"
                        onMouseEnter={() => setIsHoveringPhone(true)}
                        onMouseLeave={() => setIsHoveringPhone(false)}
                    >
                    

                {/* <Header page="Today" /> */}

                <div style={{ width: "100%", height: "100%" }}>
                    {/* <AnimatePresence mode=""> */}

                    {/* <Routes location={location} key={location.pathname}> */}
                    <Routes>
                        <Route path="/" element={<PrivateRoute><Today /></PrivateRoute>} />
                        <Route path="/markets/*" element={<PrivateRoute><Markets isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}/></PrivateRoute>} />
                        <Route path="/mywsj" element={<PrivateRoute><MyWSJ /></PrivateRoute>} />
                        <Route path="/media" element={<PrivateRoute><Media /></PrivateRoute>} />
                        <Route path="/more" element={<PrivateRoute><More /></PrivateRoute>} />
                        <Route path="/myqueue" element={<PrivateRoute><MyQueue /></PrivateRoute>} />
                        <Route path="/assistant" element={<PrivateRoute><Assistant /></PrivateRoute>} />
                        <Route path="/takashi/*" element={<PrivateRoute><TakashiPlayground /></PrivateRoute>} />
                        <Route path="/tiange" element={<PrivateRoute><Tiange /></PrivateRoute>} />
                        {/* <Route path="/company" element={<PrivateRoute><Company /></PrivateRoute>} /> */}
                        <Route path="/company/:ticker" element={<PrivateRoute><Company /></PrivateRoute>} />
                        <Route path="/create-watchlist" element={<CreateWatchlist />} />
                        <Route path="/markets/*" element={<PrivateRoute><Markets isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}/></PrivateRoute>} />
                        {/* <Route path="/cover" element={<PrivateRoute><Cover /></PrivateRoute>} /> */}


                        {/* Auth routes */}
                        <Route path="/signin" element={<SignIn />} />
                        {/* <Route path="/cover" element={<Cover />} /> */}
                    
                        {/* <Route path="/signup" element={<SignUp />} /> */}
                    </Routes>
                    {/* </AnimatePresence> */}
                </div>




                {/* Bottom tab navigation fixed at the bottom */}
                
                {/* Conditionally render the bottom nav unless path === /company */}
                {location.pathname.startsWith("/company/") || location.pathname === "/signin" || location.pathname === "/signout" || location.pathname.startsWith("/create-watchlist") ? null : <BottomTabNav />}

                {isModalOpen && (<Modal setIsModalOpen={setIsModalOpen}/>)}
                </div>


            </div>
        </>
    )
}

function App() {
    return (
        <GlitchProvider>
            <Router>
                <AppContent />
            </Router>
        </GlitchProvider>
    );
}

export default App;